import React from "react";

const SaveConfirmationModal = ({ onSave, onDiscard, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4 text-purple-400">
          Save Your Changes?
        </h2>
        <p className="mb-6 text-gray-300">
          Your note has unsaved changes. Would you like to save them before
          leaving?
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onSave}
            className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600"
          >
            Save Changes
          </button>
          <button
            onClick={onDiscard}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Don't Save
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-300 hover:text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveConfirmationModal;
